<template>
    <div class="flex min-h-screen items-center justify-center">
        <div
            class="mx-4 flex max-w-3xl flex-col justify-start rounded p-4 text-white shadow-md md:w-full">
            <div class="mb-5 flex flex-col items-center justify-center"><ApplicationLogo /></div>

            <!-- Alabama and Missouri specific warning -->
            <div
                v-if="propsPage.userState === 'AL' || propsPage.userState === 'MO'"
                class="mb-6 rounded-lg border-2 border-yellow-500 bg-yellow-900/20 p-5 text-sm">
                <h3 class="mb-3 text-lg font-bold text-yellow-400">
                    {{ propsPage.userState === 'AL' ? 'Alabama' : 'Missouri' }} Health and Human
                    Services Warning
                </h3>

                <p class="mb-3">
                    Pornography is potentially biologically addictive, is proven to harm human brain
                    development, desensitizes brain reward circuits, increases conditioned
                    responses, and weakens brain function.
                </p>

                <p class="mb-3">
                    Exposure to this content is associated with low self-esteem and body image,
                    eating disorders, impaired brain development, and other emotional and mental
                    illnesses.
                </p>

                <p class="mb-4">
                    Pornography increases the demand for prostitution, child exploitation, and child
                    pornography.
                </p>

                <div class="border-t border-yellow-500/30 pt-4">
                    <p class="mb-2 font-semibold text-yellow-400">
                        U.S. Substance Abuse and Mental Health Services Administration Helpline
                    </p>
                    <p class="mb-2 text-lg font-bold">1-800-662-HELP (4357)</p>
                    <p class="text-xs">
                        This helpline is a free, confidential information service (in English or
                        Spanish) open 24 hours per day, for individuals and family members facing
                        mental health or substance use disorders. The service provides referral to
                        local treatment facilities, support groups, and community-based
                        organizations.
                    </p>
                </div>
            </div>

            <div class="mb-5 text-center text-lg">
                We understand the importance of safety and compliance with legal regulations. To
                access our content, we need to verify that you are of legal age.
            </div>
            <div v-if="!qrCodeSrc && statusEmblem !== 'approved' && showOptions">
                <p class="mb-8 text-center">Choose your preferred verification method</p>
                <div
                    class="mx-auto mb-10 flex max-w-lg flex-col items-center justify-center gap-4 sm:flex-row">
                    <!-- Phone Number Option -->
                    <button
                        v-if="
                            verifyTypes.includes(PHONE) &&
                            String(propsPage.vmaCountry).toLowerCase() === 'us'
                        "
                        @click="handleSelectOption('phone')"
                        class="flex h-36 w-full flex-col items-center justify-center rounded-lg border border-gray-600 p-6 transition-all hover:border-[#65E8A4] hover:bg-gray-800 sm:w-48">
                        <div>
                            <svg
                                class="mb-4 h-auto w-10 text-[#65E8A4]"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24">
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                            </svg>
                        </div>
                        <span class="text-lg font-medium">Phone Number</span>
                    </button>

                    <!-- ssn Number Option -->
                    <button
                        v-if="
                            verifyTypes.includes(SSN) &&
                            String(propsPage.vmaCountry).toLowerCase() === 'us'
                        "
                        @click="handleSelectOption('ssn')"
                        class="flex h-36 w-full flex-col items-center justify-center rounded-lg border border-gray-600 p-6 transition-all hover:border-[#65E8A4] hover:bg-gray-800 sm:w-48">
                        <div>
                            <svg
                                class="mb-4 h-12 w-12 text-[#65E8A4]"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24">
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2" />
                            </svg>
                        </div>
                        <span class="text-lg font-medium">SSN Verification</span>
                    </button>

                    <!-- ID Upload Option -->
                    <button
                        v-if="verifyTypes.includes(ID)"
                        @click="handleSelectOption('faceId')"
                        class="flex h-36 w-full flex-col items-center justify-center rounded-lg border border-gray-600 p-6 transition-all hover:border-[#65E8A4] hover:bg-gray-800 sm:w-48">
                        <div>
                            <svg
                                class="mb-4 h-auto w-10 text-[#65E8A4]"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24">
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5zm6-10.125a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zm1.294 6.336a6.721 6.721 0 01-3.17.789 6.721 6.721 0 01-3.168-.789 3.376 3.376 0 016.338 0z" />
                            </svg>
                        </div>
                        <span class="text-lg font-medium">ID Upload</span>
                    </button>
                    <button
                        v-if="verifyTypes.includes(ID_EMBLEM)"
                        @click="handleSelectOption('faceIdEmblem')"
                        class="flex h-36 w-full flex-col items-center justify-center rounded-lg border border-gray-600 p-6 transition-all hover:border-[#65E8A4] hover:bg-gray-800 sm:w-48">
                        <div>
                            <svg
                                class="mb-4 h-auto w-10 text-[#65E8A4]"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24">
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5zm6-10.125a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zm1.294 6.336a6.721 6.721 0 01-3.17.789 6.721 6.721 0 01-3.168-.789 3.376 3.376 0 016.338 0z" />
                            </svg>
                        </div>
                        <span class="text-lg font-medium">ID Upload Emblem</span>
                    </button>

                    <!-- Email Option -->
                    <button
                        v-if="propsPage.vmaCountry && verifyTypes.includes(EMAIL)"
                        @click="handleSelectOption('email')"
                        class="flex h-36 w-full flex-col items-center justify-center rounded-lg border border-gray-600 p-6 transition-all hover:border-[#65E8A4] hover:bg-gray-800 sm:w-48">
                        <div>
                            <font-awesome-icon
                                class="mb-4 h-auto w-10 text-[#65E8A4]"
                                :icon="['far', 'fa-envelope']" />
                        </div>
                        <span class="text-lg font-medium">Email {{ propsPage.vmaCountry }}</span>
                    </button>
                </div>

                <div
                    v-if="vmaEmailError"
                    class="text-medium mb-4 mt-8 rounded-lg bg-red-50 p-4 text-red-800 dark:bg-gray-800 dark:text-red-400"
                    role="alert">
                    <span class="font-medium"> {{ vmaEmailError }} </span>
                </div>
            </div>
            <div v-if="!showConfirmation && currentOptionVerification === 'phone'">
                <form @submit.prevent="submit" class="mx-auto max-w-sm">
                    <label
                        for="dropdown-phone-button"
                        class="mb-2 block text-sm font-medium text-gray-900 dark:text-white"
                        >Phone number:</label
                    >
                    <div class="flex items-center justify-center">
                        <button
                            id="dropdown-phone-button"
                            data-dropdown-toggle="dropdown-phone"
                            class="z-10 inline-flex flex-shrink-0 items-center rounded-s-lg border border-gray-300 bg-gray-100 px-4 py-2.5 text-center text-sm font-medium text-gray-900 hover:bg-gray-200 focus:outline-none focus:ring-4 focus:ring-gray-100 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:hover:bg-mintgreen dark:hover:text-black dark:focus:ring-gray-700"
                            type="button">
                            <FlagCode :code="countryCode" />

                            {{ countryCode }}
                            <svg
                                class="ms-2.5 h-2.5 w-2.5"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 10 6">
                                <path
                                    stroke="currentColor"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="m1 1 4 4 4-4" />
                            </svg>
                        </button>
                        <div
                            id="dropdown-phone"
                            class="z-10 hidden w-52 divide-y divide-gray-100 rounded-lg bg-white shadow dark:bg-gray-700">
                            <ul
                                class="py-2 text-sm text-gray-700 dark:text-gray-200"
                                aria-labelledby="dropdown-phone-button">
                                <li v-for="code in codes">
                                    <button
                                        type="button"
                                        class="inline-flex w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-600 dark:hover:text-white"
                                        role="menuitem"
                                        @click="handleCountyCode(code.value)">
                                        <div class="inline-flex items-center">
                                            <FlagCode :code="code.value" />
                                            {{ code.label }}
                                        </div>
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <label
                            for="phone-input"
                            class="sr-only mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Phone number:</label
                        >
                        <div class="relative w-full">
                            <input
                                v-model="phone"
                                type="text"
                                id="phone-input"
                                class="z-20 block w-full rounded-e-lg border border-s-0 border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:border-s-gray-700 dark:bg-[#eaeaea] dark:text-[#000] dark:placeholder-gray-400 dark:focus:border-blue-500"
                                placeholder="(123) 456-7890"
                                required />
                        </div>
                    </div>
                    <div class="mt-4 flex w-full items-center justify-center">
                        <PrimaryButton
                            class="mt-4 flex !rounded-full border !border-mintgreen px-8 py-3 text-white">
                            Verify Phone
                        </PrimaryButton>
                    </div>
                </form>
            </div>
            <div v-if="currentOptionVerification === 'faceId' && !qrCodeSrc">
                <form
                    class="mx-auto mt-10 max-w-sm"
                    @submit.prevent="submitFaceId"
                    name="faceId-form">
                    <div class="mb-8">
                        <div class="text-center">
                            <h2 class="mb-4 text-xl font-semibold">Photo ID Verification</h2>
                            <p class="mb-4 text-sm">
                                Please verify your age by uploading a valid government-issued photo
                                ID.
                            </p>
                        </div>

                        <div class="mb-4">
                            <label for="email" class="mb-2 block text-sm font-medium text-white"
                                >Email address</label
                            >
                            <input
                                type="email"
                                id="email"
                                name="email"
                                v-model="email"
                                class="block w-full rounded-lg border border-gray-600 bg-[#eaeaea] p-2.5 text-sm text-[#000] placeholder-gray-400 focus:border-blue-500 focus:ring-blue-500"
                                placeholder="name@example.com"
                                required />
                        </div>

                        <div class="mb-4">
                            <label for="dob" class="mb-2 block text-sm font-medium text-white"
                                >Date of Birth</label
                            >
                            <input
                                type="date"
                                id="dob"
                                name="dob"
                                v-model="dateOfBirth"
                                class="block w-full rounded-lg border border-gray-600 bg-[#eaeaea] p-2.5 text-sm text-[#000] placeholder-gray-400 focus:border-blue-500 focus:ring-blue-500"
                                required />
                        </div>
                        <!-- @endif -->

                        <div id="bluecheck-container" class="mx-auto max-w-md">
                            <div id="bluecheck-button-container" class="flex justify-center">
                                <button
                                    :disabled="isBlockSendId"
                                    type="submit"
                                    id="start-verification"
                                    class="mt-4 flex !rounded-full border !border-[#65E8A4] bg-[#65E8A4] px-8 py-3 font-semibold text-black transition duration-150 ease-in-out hover:bg-[#65E8A4] hover:text-black focus:outline-none focus:ring-0 focus:ring-[#65E8A4] focus:ring-offset-0">
                                    Start ID Verification
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <!-- SSN Verification Form -->
            <div v-if="currentOptionVerification === 'ssn' && statusBlueCheck !== 'approved'">
                <div
                    v-if="vmaSsnError"
                    class="text-medium mb-4 mt-8 rounded-lg bg-red-50 p-4 text-red-800 dark:bg-gray-800 dark:text-red-400"
                    role="alert">
                    <span class="font-medium"> {{ vmaSsnError }} </span>
                </div>
                <form @submit.prevent="submitSsn" class="mx-auto max-w-sm">
                    <div class="mb-4">
                        <label for="first_name" class="mb-2 block text-sm font-medium text-white">
                            First Name:
                        </label>
                        <input
                            type="text"
                            id="first_name"
                            name="first_name"
                            class="block w-full rounded-lg border border-gray-600 bg-[#eaeaea] p-2.5 text-sm text-[#000] placeholder-gray-400 focus:border-blue-500 focus:ring-blue-500"
                            placeholder="John"
                            v-model="ssnFirstName"
                            required />
                    </div>

                    <div class="mb-4">
                        <label for="last_name" class="mb-2 block text-sm font-medium text-white">
                            Last Name:
                        </label>
                        <input
                            type="text"
                            id="last_name"
                            name="last_name"
                            class="block w-full rounded-lg border border-gray-600 bg-[#eaeaea] p-2.5 text-sm text-[#000] placeholder-gray-400 focus:border-blue-500 focus:ring-blue-500"
                            placeholder="Smith"
                            v-model="ssnLastName"
                            required />
                    </div>

                    <div class="mb-4">
                        <label for="ssn4" class="mb-2 block text-sm font-medium text-white">
                            Last 4 Digits of SSN:
                        </label>
                        <input
                            type="text"
                            id="ssn4"
                            name="ssn4"
                            maxlength="4"
                            pattern="\d{4}"
                            class="block w-full rounded-lg border border-gray-600 bg-[#eaeaea] p-2.5 text-sm text-[#000] placeholder-gray-400 focus:border-blue-500 focus:ring-blue-500"
                            placeholder="1234"
                            v-model="ssnNumber"
                            required />
                    </div>

                    <div class="mb-4">
                        <label for="dob-ssn" class="mb-2 block text-sm font-medium text-white">
                            Date of Birth:
                        </label>
                        <input
                            type="date"
                            id="dob-ssn"
                            name="dob"
                            class="block w-full rounded-lg border border-gray-600 bg-[#eaeaea] p-2.5 text-sm text-[#000] placeholder-gray-400 focus:border-blue-500 focus:ring-blue-500"
                            v-model="ssnDateOfBirth"
                            required />
                    </div>

                    <div class="mt-1 flex w-full flex-col items-center justify-center">
                        <button
                            type="submit"
                            class="mt-4 flex !rounded-full border !border-[#65E8A4] px-8 py-3 font-semibold text-white transition duration-150 ease-in-out hover:bg-[#65E8A4] hover:text-black focus:outline-none focus:ring-0 focus:ring-[#65E8A4] focus:ring-offset-0">
                            Verify Age
                        </button>
                    </div>
                </form>
            </div>

            <!-- Email Verification Form -->
            <div v-if="currentOptionVerification === 'email'">
                <form @submit.prevent="startEmailVerification" class="mx-auto max-w-sm">
                    <div class="mb-4">
                        <label for="email" class="mb-2 block text-sm font-medium text-white">
                            Email:
                        </label>
                        <input
                            type="text"
                            id="email"
                            name="email"
                            class="block w-full rounded-lg border border-gray-600 bg-[#eaeaea] p-2.5 text-sm text-[#000] placeholder-gray-400 focus:border-blue-500 focus:ring-blue-500"
                            placeholder="placeholder@email.com"
                            v-model="vmaEmailInput"
                            required />
                    </div>

                    <div class="mt-1 flex w-full flex-col items-center justify-center">
                        <button
                            type="submit"
                            class="mt-4 flex !rounded-full border !border-[#65E8A4] px-8 py-3 font-semibold text-white transition duration-150 ease-in-out hover:bg-[#65E8A4] hover:text-black focus:outline-none focus:ring-0 focus:ring-[#65E8A4] focus:ring-offset-0">
                            Start Email Verification
                        </button>
                    </div>
                </form>
            </div>

            <div v-if="qrCodeSrc && statusBlueCheck !== 'approved'" class="mx-auto mt-10 max-w-sm">
                <div class="mb-8 text-center">
                    <h2 class="mb-4 text-xl font-semibold">Use your smartphone</h2>
                    <p class="mb-4 text-sm">
                        For efficient identity verification, scan this QR code with your phone's
                        native camera app
                    </p>

                    <div class="mt-12 h-48">
                        <img class="mx-auto" :src="qrCodeSrc" alt="qr code" />
                    </div>
                    <div class="mt-2">
                        <p class="py-8 text-sm text-gray-500">or</p>
                        <a
                            class="inline-flex cursor-pointer items-center rounded-md border border-transparent bg-gray-800 px-4 py-2 text-xs font-semibold uppercase tracking-widest text-white transition duration-150 ease-in-out hover:bg-gray-700 focus:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 active:bg-gray-900"
                            target="_blank"
                            :href="publicUrl">
                            Continue on this device
                        </a>
                    </div>
                </div>
            </div>
            <div
                v-if="statusBlueCheck === 'approved' || statusEmblem === 'approved'"
                class="mx-auto mt-10 max-w-sm">
                <div class="mb-8 text-center font-semibold">
                    <h2 class="mb-4 text-xl font-semibold">
                        You will be redirected back to the site in:
                    </h2>
                    <div class="flex flex-col items-center justify-center py-4">
                        <h1 class="text-5xl">{{ seconds }}</h1>
                        <span class="font-medium text-white">seconds</span>
                    </div>
                    <div>
                        <Link :href="route('home')" class="text-mintgreen">Please click here</Link>
                        if you are not redirected within a few seconds
                    </div>
                </div>
            </div>
            <div
                class="mx-auto mt-10 max-w-sm"
                v-if="statusBlueCheck && qrCodeSrc && statusBlueCheck !== 'approved'">
                <div class="mb-8 text-center">
                    <h2 class="mb-4 text-xl font-semibold">Photo ID Verification</h2>
                    <span class="font-semibold text-white">Status: {{ statusBlueCheck }}</span>
                    <p v-if="statusBlueCheck == 'waiting'" class="mb-4 text-sm">
                        The verification is waiting on additional information and or data from the
                        user.
                    </p>
                    <p v-if="statusBlueCheck == 'pending'" class="mb-4 text-sm">
                        The verification is currently processing the verification.
                    </p>
                    <p v-if="statusBlueCheck == 'approved'" class="mb-4 text-sm">
                        The verification has been completed and the data was verified.
                    </p>
                    <p v-if="statusBlueCheck == 'rejected'" class="mb-4 text-sm text-red-500">
                        The verification has been completed but the data could not be verified.
                    </p>
                    <p v-if="statusBlueCheck == 'cancelled'" class="mb-4 text-sm text-red-500">
                        The verification is cancelled and unable to be completed by the end user.
                    </p>
                    <p v-if="reasonBlueCheck" class="mb-4 text-sm">{{ $reason }}</p>
                </div>
            </div>
            <!-- waiting for verification -->
            <div v-if="showWaiting">
                <div class="mb-8 text-center">
                    <h2 class="mb-4 text-xl font-semibold">ID Verification</h2>
                    <p class="mb-4 font-medium">Please wait for the verification to be completed</p>
                    <!-- spin loader -->
                    <div class="flex justify-center">
                        <div>
                            <svg
                                class="-ml-1 mr-3 h-10 w-10 animate-spin text-mintgreen"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24">
                                <circle
                                    class="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    stroke-width="4"></circle>
                                <path
                                    class="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="showConfirmation">
                <form @submit.prevent="submitCode" class="mx-auto max-w-sm">
                    <p class="py-2 text-sm font-semibold">
                        You will receive a text message with a code, please enter that verification
                        code below
                    </p>
                    <label
                        for="dropdown-phone-button"
                        class="mb-2 block text-sm font-medium text-gray-900 dark:text-white"
                        >Enter code:</label
                    >
                    <div class="flex items-center justify-center">
                        <label
                            for="phone-input"
                            class="sr-only mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Phone number:</label
                        >
                        <div class="relative w-full">
                            <input
                                v-model="confirmationCode"
                                type="text"
                                id="phone-input"
                                class="z-20 block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-[#eaeaea] dark:text-[#000] dark:placeholder-gray-400 dark:focus:border-blue-500"
                                placeholder="12345"
                                maxlength="5"
                                minlength="5"
                                required />
                        </div>
                    </div>
                    <button
                        @click="backPhone"
                        type="button"
                        class="cursor-pointer p-2 text-sm text-white underline">
                        back
                    </button>
                    <div class="mt-4 flex w-full items-center justify-center">
                        <PrimaryButton
                            class="mt-4 flex !rounded-full border !border-mintgreen px-8 py-3 text-white">
                            Verify Code
                        </PrimaryButton>
                    </div>
                </form>
            </div>
            <div
                v-if="showErrorMessage"
                class="text-medium mb-4 mt-8 rounded-lg bg-red-50 p-4 text-red-800 dark:bg-gray-800 dark:text-red-400"
                role="alert">
                <span class="font-medium">
                    We're sorry, but we were unable to verify your age.
                </span>
                If you believe there was an error, please verify your phone number and try again.
                <br /><br />
                If you continue to experience issues with the age verification process, or if you
                have any questions, please don't hesitate to contact us for assistance.

                <p class="mt-4 text-center text-lg leading-loose">
                    <a href="mailto:support@fyf.com" class="inline-block text-mintgreen"
                        >support@fyf.com</a
                    >
                </p>
            </div>

            <div class="card my-8 text-sm text-white">
                <Accordion :activeIndex="0">
                    <AccordionTab header="Your Privacy is Important to Us">
                        <p class="m-0 text-white">
                            In our commitment to ensuring a safe and trustworthy environment, we
                            require a quick phone number verification to confirm your age. Please
                            understand that this process is solely for age verification purposes and
                            adheres strictly to our privacy policy.
                        </p>
                    </AccordionTab>
                    <AccordionTab header="Here's Our Promise to You:">
                        <ul class="list-disc px-4 [&>li]:py-2">
                            <li>
                                No Storage of Your Phone Number:** We do not store, record, or keep
                                your phone number in any form after verification is complete. Your
                                phone number is used only once for the purpose of age verification
                                and then immediately discarded.
                            </li>
                            <li>
                                One-Time Use:** Your phone number is solely used for a one-time
                                verification process. There are no records maintained
                                post-verification, ensuring your personal information remains
                                private and secure.
                            </li>
                            <li>
                                No Marketing Calls or SMS:** Submitting your phone number for age
                                verification will not result in marketing calls, SMS, or any
                                unsolicited communication. We respect your privacy and your peace of
                                mind.
                            </li>
                        </ul>
                    </AccordionTab>
                    <AccordionTab header="Why Phone Number Verification?">
                        <p class="m-0">
                            Using your phone number for a quick verification helps us maintain a
                            secure environment and ensures that our services are responsibly used.
                            This process is straightforward, safe, and respects your privacy at
                            every step.
                        </p>
                        <p class="mt-2">
                            Should you have any concerns or questions about this process, please
                            feel free to reach out to us at
                            <a href="mailto:support@fyf.com" class="inline-block text-mintgreen"
                                >support@fyf.com</a
                            >. Your trust and safety are our top priorities.
                        </p>
                    </AccordionTab>
                </Accordion>
            </div>
        </div>
    </div>
    <Toast
        :show="showErrorToast"
        iconColor="text-red-500"
        iconBgColor="bg-red-100"
        position="bottomLeft"
        transitionName="fade"
        :text="errorMessage || 'Please insert a valid phone number.'"
        :transitionEnter="300"
        :transitionLeave="500"
        @closeButton="closeButton">
    </Toast>

    <Toast
        :show="showSuccessToast"
        iconColor="text-green-500"
        iconBgColor="bg-green-100"
        position="bottomLeft"
        transitionName="fade"
        :text="messageSuccessToast || 'Phone validation was successful'"
        :transitionEnter="300"
        :transitionLeave="500"
        @closeButton="closeButton">
    </Toast>
</template>

<script setup>
    import { onUpdated, ref, watchEffect, onMounted, onUnmounted } from 'vue'
    import EmptyLayout from '@/Layouts/EmptyLayout.vue'
    import ApplicationLogo from '@/Components/ApplicationLogo.vue'
    import { initFlowbite } from 'flowbite'
    import FlagCode from '@/Components/FlagCode.vue'
    import PrimaryButton from '@/Components/PrimaryButton.vue'
    import Toast from '@/Components/Toast.vue'
    import { router, usePage } from '@inertiajs/vue3'
    import Accordion from 'primevue/accordion'
    import AccordionTab from 'primevue/accordiontab'
    import useSWRV from 'swrv'
    import { Link } from '@inertiajs/vue3'
    import EmblemSDK from '@/lib/emblem-sdk'

    defineOptions({ layout: EmptyLayout })
    const { props: propsPage } = usePage()

    const verifyTypes = propsPage.verify_types

    const phone = ref('')
    const countryCode = ref('+1')
    const phoneFull = ref('')

    const email = ref('')
    const dateOfBirth = ref('')
    const showErrorToast = ref(false)
    const isPageVisible = ref(true)

    const ssnFirstName = ref('')
    const ssnLastName = ref('')
    const ssnDateOfBirth = ref('')
    const ssnNumber = ref('')
    const messageSuccessToast = ref('')

    const ID = 1
    const PHONE = 2
    const EMAIL = 3
    const ID_EMBLEM = 4
    const SSN = 5

    const handleVisibilityChange = () => {
        isPageVisible.value = !document.hidden
        console.log('isPageVisible', isPageVisible.value)
    }

    onMounted(() => {
        document.addEventListener('visibilitychange', handleVisibilityChange)
    })

    onUnmounted(() => {
        document.removeEventListener('visibilitychange', handleVisibilityChange)
    })
    const showSuccessToast = ref(false)
    const showErrorMessage = ref(false)
    const showConfirmation = ref(false)
    const confirmationCode = ref('')
    const errorMessage = ref('')
    const uuid = ref('')
    const publicUrl = ref(propsPage.publicUrl || '')
    const qrCodeSrc = ref(propsPage.qrCodeSrc || '')
    const currentOptionVerification = ref('')
    const reasonBlueCheck = ref(propsPage.reason || '')
    const isBlockSendId = ref(false)
    const seconds = ref(0)
    const initCountdown = ref(false)

    const statusBlueCheck = ref(propsPage.statusBlueCheck || '')
    const statusEmblem = ref('')
    const showOptions = ref(true)
    const showWaiting = ref(false)
    const vmaEmailInput = ref('')
    const vmaEmailError = ref('')
    const vmaSsnError = ref('')

    const codes = ref([{ value: '+1', label: 'United States (+1)' }])
    onUpdated(() => {
        initFlowbite()
    })

    watchEffect(() => {
        const originalCleaned = `${phone?.value || ''}`.match(/\d+/g)
        const original = originalCleaned?.join('')

        const phoneValue = `${countryCode.value}${original || ''}`

        const phoneNumber = formatPhoneNumber(phone.value)
        phoneFull.value = phoneValue
        if (phoneNumber) {
            phone.value = phoneNumber
        }
    })

    const handleCountyCode = value => {
        countryCode.value = value
    }

    const backPhone = () => {
        showConfirmation.value = false
    }

    const submit = () => {
        showErrorMessage.value = false
        errorMessage.value = ''
        if (!phoneFull.value) {
            return
        }
        axios
            .post(route('ageCheckPhone'), {
                phone: phoneFull.value,
            })
            .then(async res => {
                const data = res.data
                if (
                    data?.confirmation &&
                    data?.confirmation?.uuid &&
                    !data?.confirmation?.confirmed
                ) {
                    showConfirmation.value = true
                    uuid.value = data?.confirmation?.uuid
                } else {
                    if (data?.confirmation?.message) {
                        errorMessage.value = data?.confirmation?.message
                    }
                    showErrorToast.value = true
                    showErrorMessage.value = true
                }
            })
            .catch(e => {
                showErrorToast.value = true
            })
    }

    const submitFaceId = () => {
        showErrorMessage.value = false
        errorMessage.value = ''
        isBlockSendId.value = true
        axios
            .post(route('age.verificationStart'), {
                email: email.value,
                dob: dateOfBirth.value,
            })
            .then(async res => {
                const data = res.data
                if (data?.publicUrl) {
                    publicUrl.value = data?.publicUrl
                    qrCodeSrc.value = data?.qrCodeSrc
                    showConfirmation.value = false
                    statusBlueCheck.value = data?.statusBlueCheck
                } else {
                    errorMessage.value = 'Please review the submitted form for errors'
                    showErrorToast.value = true
                    showErrorMessage.value = true
                }
                reasonBlueCheck.value = data?.reason
                isBlockSendId.value = false
            })
            .catch(e => {
                showErrorToast.value = true
                isBlockSendId.value = false
            })
    }

    const submitCode = () => {
        showErrorMessage.value = false
        errorMessage.value = ''
        if (!confirmationCode.value) {
            return
        }
        axios
            .post(route('ageCheckCode'), {
                uuid: uuid.value,
                code: confirmationCode.value,
                phone: phoneFull.value,
            })
            .then(async res => {
                const data = res.data
                if (
                    data?.confirmation &&
                    data?.confirmation?.uuid &&
                    data?.confirmation?.confirmed
                ) {
                    showSuccessToast.value = true
                    showErrorMessage.value = false
                    router.visit('/home')
                } else {
                    if (data?.confirmation?.message) {
                        errorMessage.value = data?.confirmation?.message
                    }
                    showErrorToast.value = true
                    showErrorMessage.value = true
                }
            })
            .catch(e => {
                showErrorToast.value = true
            })
    }

    const submitSsn = () => {
        showErrorMessage.value = false
        vmaSsnError.value = ''
        messageSuccessToast.value = ''
        if (
            !ssnFirstName.value ||
            !ssnLastName.value ||
            !ssnNumber.value ||
            !ssnDateOfBirth.value
        ) {
            return
        }
        axios
            .post(route('age.check.ssn'), {
                first_name: ssnFirstName.value,
                last_name: ssnLastName.value,
                ssn4: ssnNumber.value,
                dob: ssnDateOfBirth.value,
            })
            .then(async res => {
                if (res.data.status == 'success') {
                    statusBlueCheck.value = 'approved'
                    messageSuccessToast.value = 'SSN verification was successful'
                    showSuccessToast.value = true
                    showErrorMessage.value = false
                } else {
                    vmaSsnError.value = 'Please review your SSN information, match not found'
                    errorMessage.value = res.data.message
                    showErrorToast.value = true
                }
            })
            .catch(e => {
                vmaSsnError.value = e.response.data.message
                errorMessage.value = 'Please review your SSN information'
                showErrorToast.value = true
            })
            .finally(() => {
                setTimeout(() => {
                    vmaSsnError.value = ''
                    showErrorToast.value = false
                    showSuccessToast.value = false
                }, 5000)
            })
    }
    const closeButton = () => {
        showErrorToast.value = false
        showSuccessToast.value = false
    }

    function formatPhoneNumber(phoneNo) {
        var originalCleaned = (phone.value || '').match(/\d+/g)
        var cleaned = phoneNo.match(/\d+/g)
        const length = cleaned ? cleaned?.length : 0
        if (length > 0) {
            const textPhone = cleaned.join('')
            const original = originalCleaned.join('')
            if (textPhone.length >= 3) {
                let value = `(${textPhone.substring(0, 3)}) ${textPhone.substring(3, 6)}`
                if (value.length == 9 && original.length > value.length) {
                    value += `-`
                }
                value += `${textPhone.substring(6, 10)}`

                return value
            } else {
                return cleaned.join('')
            }
        }

        return phoneNo
    }

    const handleSelectOption = option => {
        currentOptionVerification.value = option
        if (option == 'faceIdEmblem') {
            startVerification()
        }
    }

    const {
        data: dataBlueCheck,
        error,
        isLoading,
    } = useSWRV(
        () => route('age.verificationCheck'),
        () => axios.post(route('age.verificationCheck')),
        {
            refreshInterval: 2000,
        },
    )

    watchEffect(() => {
        const data = dataBlueCheck?.value?.data
        if (data) {
            statusBlueCheck.value = data?.statusBlueCheck
            reasonBlueCheck.value = data?.reason
            console.log('statusBlueCheck.value', data)
        }
    }, [dataBlueCheck])

    // check statusBlueCheck and start down timer
    watchEffect(() => {
        if (statusBlueCheck.value == 'approved' && isPageVisible.value) {
            initCountdown.value = true
            showOptions.value = false
        }
    }, [statusBlueCheck, isPageVisible])

    // check statusEmblem and start down timer
    watchEffect(() => {
        if (statusEmblem.value == 'approved' && isPageVisible.value) {
            initCountdown.value = true
            showOptions.value = false
        }
    }, [statusEmblem, isPageVisible])

    let countdownInterval = null

    watchEffect(() => {
        if (initCountdown.value) {
            seconds.value = 5
            showWaiting.value = false
            if (countdownInterval) {
                clearInterval(countdownInterval)
            }
            countdownInterval = setInterval(() => {
                seconds.value--
                if (seconds.value === 0) {
                    clearInterval(countdownInterval)
                    countdownInterval = null
                    router.visit(route('home'))
                }
            }, 1000)
        } else if (countdownInterval) {
            clearInterval(countdownInterval)
            countdownInterval = null
            seconds.value = 5
        }
    }, [initCountdown])

    var emblem

    function initEmblem(uuid) {
        const emblemConfig = propsPage.emblemConfig
        emblem = new EmblemSDK({
            url: emblemConfig.domain_url,
            projectKey: emblemConfig.project_key,
            state: JSON.stringify({
                uuid: uuid,
            }),
            // state: "userId-" + uuid,
            reviewRedirectUrl: route('ageCheckVerification', { uuid: uuid }),
            postbackUrl: emblemConfig.postback_url,
            postbackHeaders: JSON.stringify({
                'x-gateway': uuid,
            }),
        })

        // Configurar callbacks
        let verificationInterval
        emblem
            .onVerificationClick(() => {
                console.log('Verification clicked')
                // showWaiting.value = true
                verificationInterval = setInterval(() => {
                    completeVerification(uuid, false)
                }, 5000)
            })
            .onWindowClose(() => {
                if (verificationInterval) {
                    clearInterval(verificationInterval)
                }
                completeVerification(uuid)
            })
    }

    function startVerification() {
        axios
            .post(route('age.verification.start.emblem'), {})
            .then(response => {
                console.log('Verification window opened')
                const uuid = response.data.uuid
                initEmblem(uuid)
                emblem.verify()
            })
            .catch(error => {
                console.log(error)
            })
    }

    function completeVerification(uuid, makeRedirectFails = true) {
        axios
            .post(route('age.verification.completed.emblem'), {
                uuid: uuid,
            })
            .then(response => {
                console.log('Verification window opened')
                const redirectUrl = response.data.redirect_url
                const status = response.data.status
                // redirect to next step
                if (redirectUrl && status == 'success') {
                    statusEmblem.value = 'approved'
                    return
                } else if (makeRedirectFails && redirectUrl) {
                    window.location.href = redirectUrl
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    function startEmailVerification() {
        vmaEmailError.value = ''

        if (!vmaEmailInput.value) {
            vmaEmailError.value = 'Please enter an email address'
            return
        }

        axios
            .post(
                route('vma.email.start', {
                    email: vmaEmailInput.value,
                }),
            )
            .then(response => {
                if (response.data.start_verification_url) {
                    let a = document.createElement('a')
                    a.href = response.data.start_verification_url
                    a.click()
                } else {
                    vmaEmailError.value =
                        response.data.message || 'Something went wrong. Please try again.'
                }
            })
            .catch(error => {
                if (error?.response?.data?.message) {
                    vmaEmailError.value = error?.response?.data?.message
                }
                console.error(error)
            })
    }

    onMounted(() => {
        // check if the url has uuid
        const urlParams = new URLSearchParams(window.location.search)
        const uuid = urlParams.get('uuid')
        if (uuid) {
            showOptions.value = false
            showWaiting.value = true
            setInterval(() => {
                completeVerification(uuid, false)
            }, 5000)
        }
    })
</script>
